import { ProductOrBrand } from "./alternativeTypes";

export const messagingProducts: ProductOrBrand[] = [
  {
    name: "Messenger",
    ownerCountry: "US",
    categories: ["messaging"],
  },
  {
    name: "WhatsApp",
    ownerCountry: "US",
    categories: ["messaging"],
  },
  {
    name: "Threema",
    ownerCountry: "CH",
    categories: ["messaging"],
    sourceLinks: [
      "https://threema.ch",
      "https://en.wikipedia.org/wiki/Threema",
    ],
  },
  {
    name: "Element",
    ownerCountry: "UK",
    categories: ["messaging"],
    sourceLinks: ["https://matrix.org/ecosystem/clients/element/"],
  },
  {
    name: "Delta Chat",
    ownerCountry: "DE",
    categories: ["messaging"],
    sourceLinks: ["https://delta.chat/en/help"],
  },
  { 
    name: "Olvid", 
    ownerCountry: "FR", 
    headquarterIn: "FR", 
    availableIn: ["AL", "AM", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "MD", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SI", "ES", "SE", "CH", "TR", "UA", "UK"], 
    comments: "French encrypted instant messaging application available on mobile and desktop platforms, emphasizing high-level security through custom cryptographic protocols.", 
    categories: ["messaging"], 
    sourceLinks: ["https://en.wikipedia.org/wiki/Olvid", "https://olvid.io/"] 
  },
  {
    name: "Signal",
    ownerCountry: "US",
    isLessEvilAlternative: true,
    categories: ["messaging"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Signal_(software)"],
  },
];